import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import { BrowserRouter,Routes, Route } from "react-router-dom"
import { AuthProvider } from './context/AuthProvider';
import { MessageProvider } from './context/MessageProvider';
import { muiTheme } from './muiTheme';
import { registerServiceWorker } from './registerServiceWorker';

/*
if (process.env.NODE_ENV === 'development') {
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React, {
    trackAllPureComponents: true, // Tracks functional components
  });
}
*/

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={muiTheme}>
      <BrowserRouter>
      
      <MessageProvider>
      <AuthProvider>
        <Routes>
          <Route path="/*" element={<App/>} />
        </Routes>
      </AuthProvider>
      </MessageProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);

registerServiceWorker();


